import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";

@Component({
  selector: "app-remplacer-fichier",
  templateUrl: "./remplacer-fichier.component.html",
  styleUrls: ["./remplacer-fichier.component.scss"],
})
export class RemplacerFichierComponent implements OnInit {
  @Input() subitemId;
  @Input() codeDocument;
  @Input() displayname;

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private _gestionFichierService: GestionFichierService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      codeDocument: [null, Validators.compose([Validators.required])],
      displayName: [null, Validators.compose([Validators.required])],
      fichier: [null, Validators.compose([Validators.required])],
      checkDoc: [null, Validators.compose([Validators.required])],
      motif: [null, Validators.compose([Validators.nullValidator])],
    });
  }

  ngOnInit() {}

  remplacer(): void {
    const codedocument = this.form2.value.codeDocument;
    const displayname = this.form2.value.displayName;
    const fichier = this.form2.value.fichier.files[0];
    const commentaire = this.form2.value.motif;
    const checked = this.form2.value.checkDoc;

    this.spinner.show();
    this._gestionFichierService
      .remplacer(
        fichier,
        codedocument,
        displayname,
        checked,
        commentaire,
        this.subitemId
      )
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.errorMessage = error.error.message;
          this.spinner.hide();
        }
      );
  }
}
